<template>
  <div class="form-container" id="print">
    <div class="wrapper">
      <b-row class="text-right" align="right">
        <b-col>
          <b-form-group
            label="Status"
            label-size="sm"
            label-class="font-weight-bold"
          >
            <div
              class="status-detail"
              :class="itemRowBackground(detail.status ? detail.status : '')"
              size="sm"
              disabled
            >
              {{ detail.status ? detail.status : '' }}
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label="Company Name"
            label-size="sm"
            label-class="font-weight-bold"
          >
            <b-form-input
              autocapitalize="off"
              v-model="detail.company_name"
              placeholder="-"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Contractor Name"
            label-size="sm"
            label-class="font-weight-bold"
          >
            <b-form-input
              autocapitalize="off"
              v-model="detail.contractor_name"
              placeholder="-"
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label="Contract Number"
            label-size="sm"
            label-class="font-weight-bold"
          >
            <b-form-input
              autocapitalize="off"
              v-model="detail.contract_number"
              placeholder="-"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Contract Type"
            label-size="sm"
            label-class="font-weight-bold"
          >
            <b-form-input
              autocapitalize="off"
              v-model="detail.contract_type"
              placeholder="-"
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <div class="mt-4 mb-2">
      <div class="w-100 header-report text-center d-flex align-items-center mb-2">
        <div class="w-100">
          <img id="imgLogo"
            class="p-3"
            :src="detail.imgUrl"
            alt="logo"
            width="50%"
          >
        </div>
        <div class="w-100">
          <div class="pt-3">
            PERHITUNGAN KEMAJUAN PEKERJAAN
          </div>
          <div class="py-1">
            PROGRESS BULANAN
          </div>
          <div class="pb-3">
            Periode Produksi: {{ detail.periode_doc }}
          </div>
        </div>
        <div class="w-100">
          <h6 class="font-weight-bold">MGP Division<br> Survey Department</h6>
        </div>
      </div>
      <div class="w-100 d-flex">
        <div class="mr-2 w-100 p-3 text-center header-report bottom d-flex justify-content-between align-items-center">
          <div>Tanggal</div>
          <div>: {{ moment(detail.created_at).format('DD MMMM YYYY') }}</div>
        </div>
        <div class="mr-2 w-100 p-3 text-center header-report bottom">
          Kontaktor (Perusahaan): {{ detail.contractor_name }}
        </div>
        <div class="w-100 p-3 header-report bottom d-flex align-items-center">
          Halaman 1 dari 1
        </div>
      </div>
    </div>

    <Table
      v-for="(n, i) in detail.data.length"
      :key="n"
      :data="detail.data"
      :fields="fieldTable(i)"
      :data-table="detail.data[i].volume"
      :last-data="n === detail.data.length"
      :screen-name="'volume-work'"
    />

    <div class="mt-5 w-100 text-center d-flex font-weight-bold" v-if="detail.approval_sign.length > 0">
      <div class="w-100">
        <div class="w-100 p-1 footer-report header">
          Survey Data Processing
        </div>
        <div class="w-100 p-4 my-1 footer-report content">
          {{ getApprovalSign('Survey Owner', 'sign') }}
        </div>
        <div class="w-100 p-1 footer-report header">
          {{ getApprovalSign('Survey Owner', 'name') }}
        </div>
      </div>
      <div class="w-100 mx-1">
        <div class="w-100 p-1 footer-report header">
          Survey Head
        </div>
        <div class="w-100 p-4 my-1 footer-report content">
          {{ getApprovalSign('Superior Owner', 'sign') }}
        </div>
        <div class="w-100 p-1 footer-report header">
          {{ getApprovalSign('Superior Owner', 'name') }}
        </div>
      </div>
      <div class="w-100 mx-1">
        <div class="w-100 p-1 footer-report header">
          Mine Plan Head
        </div>
        <div class="w-100 p-4 my-1 footer-report content">
          {{ getApprovalSign('Mine Plan Head', 'sign') }}
        </div>
        <div class="w-100 p-1 footer-report header">
          {{ getApprovalSign('Mine Plan Head', 'name') }}
        </div>
      </div>
      <div class="w-100">
        <div class="w-100 p-1 footer-report header">
          MGP Head
        </div>
        <div class="w-100 p-4 my-1 footer-report content">
          {{ getApprovalSign('Manager Owner', 'sign') }}
        </div>
        <div class="w-100 p-1 footer-report header">
          {{ getApprovalSign('Manager Owner', 'name') }}
        </div>
      </div>
    </div>

    <div class="d-flex mt-5">
      <div id="history">
        <b-button
          ref="button"
          class="btn-custom mr-2"
          variant="info"
          size="sm"
          @click="isHidden = !isHidden"
        >
         Log History
        </b-button>
        <b-card
          class="log-history text-center"
          v-show="isHidden"
          v-closable="{
            exclude: ['button'],
            handler: 'onClose'
          }"
        >
          <div class="timeline small">
            <div v-if="detail.approval_history && detail.approval_history.length > 0">
              <ul class="list-history">
                <li
                  class="list-history-child"
                  v-for="(info, index) in detail.approval_history"
                  v-bind:key="index">
                  <div class="timeline-log timeline-name">
                    {{ info.fullname }} - {{ info.event }}
                  </div>
                  <div class="timeline-log timeline-status">
                    {{ info.state }}
                  </div>
                  <div class="timeline-log">
                    {{ info.comment }}
                  </div>
                  <div class="timeline-log timeline-date mb-3">
                    {{ `${moment(info.created_at).format('DD MMMM YYYY')}` }}
                  </div>
                </li>
              </ul>
            </div>
            <div v-else class="no-history">
              <h5>There is no data history in here.</h5>
            </div>
          </div>
        </b-card>
      </div>
      <b-button
        class="btn-custom mr-2"
        variant="info"
        size="sm"
        @click="onPrint"
      >
        Export
      </b-button>
      <b-button
        class="btn-reset"
        variant="outline-info"
        size="sm"
        @click="onClickBack"
      >
        {{ detail.approval_status.isActiveApprove ? 'Cancel' : 'Back' }}
      </b-button>
      <b-button
        v-if="canEdit && detail.approval_status.isEdit"
        class="btn-custom ml-auto"
        variant="info"
        size="sm"
        @click="onEdit"
      >
        Edit
      </b-button>
      <b-button
        v-if="detail.approval_status.isActiveRevise"
        class="btn-revise-cstm mr-2 ml-auto"
        variant="danger"
        size="sm"
        @click="onRevise"
        :disabled="isLoading"
      >
        Send Back
      </b-button>
      <b-button
        v-if="detail.approval_status.isActiveApprove"
        class="btn-custom"
        variant="info"
        size="sm"
        @click="onApprove"
        :disabled="isLoading"
      >
        Approve
      </b-button>
    </div>
    <modal-approve @submit="action === 'revise' ? showComment() : updateStatus()" :text="text" />
    <modal-comment @submit="updateStatus" :action="action" />
    <modal-successful :message="text" />
  </div>
</template>

<script>
import api from '@/api'
import ModalApprove from '@/partials/ModalApprove'
import ModalComment from '@/partials/ModalComment'
import ModalSuccessful from '@/partials/ModalSuccessful'
import { hasPermission } from '@/utils/permissions'
import { RESUME_VOLUME_WORK_EDIT } from '@/fixtures'
import { closeEvent } from '@/utils/closeEvent'
import Table from '@/partials/ComponentTable'

closeEvent()

export default {
  components: {
    ModalApprove,
    ModalComment,
    ModalSuccessful,
    Table
  },

  data: () => ({
    canEdit: hasPermission(RESUME_VOLUME_WORK_EDIT),
    profile: JSON.parse(localStorage.getItem('profile')),
    text: '',
    action: '',
    comment: '',
    isHidden: false,
    isLoading: false,
    showCost: true,
    detail: {
      id: '',
      no_document: '',
      company_name: '',
      contractor_name: '',
      periode_doc: '',
      created_at: '',
      created_by: '',
      imgUrl: '',
      approval_status: {
        isActiveApprove: false,
        isActiveRevise: false,
        isEdit: false
      },
      approval_sign: [
        { fullname: null },
        { fullname: null },
        { fullname: null },
        { fullname: null }
      ],
      data: [],
      status: ''
    }
  }),

  created() {
    this.fetchDetail()
  },

  computed: {
  },

  methods: {
    async fetchDetail() {
      const data = await api.summaryResumeVolumeWork.get(this.$route.params.id)
      data.approval_status.isEdit = data.status.toLowerCase() === 'revise' &&
        (
          data.approval_history.some(v => v.fullname === this.profile.fullname) ||
          this.profile.roles.name === 'Administrator' ||
          this.profile.roles.name === 'Super Admin'
        )
      if (data.approval_sign.some(v => v.name === this.profile.roles.name) && data.status.toLowerCase() !== 'revise') {
        const approval = !!data.approval_sign.find(v => v.name === this.profile.roles.name).fullname
        data.approval_status.isActiveApprove = !approval && !data.approval_status.isEdit
        data.approval_status.isActiveRevise = !approval && !data.approval_status.isEdit
      }
      this.detail = data
    },
    onClickBack() {
      this.$router.push('/summary-resume-volume-work')
    },
    onApprove() {
      this.text = 'Approve this document'
      this.action = 'approve'
      this.$bvModal.show('modal-approve')
    },
    onRevise() {
      this.text = 'Reject this document'
      this.action = 'revise'
      this.$bvModal.show('modal-approve')
    },
    showComment() {
      this.$bvModal.show('modal-comment')
    },
    onClose() {
      this.isHidden = false
    },
    onEdit() {
      this.$router.push({ path: `/summary-progress-data-survey/${this.detail.datasurvey_id}/edit`, query: { from: 'summary-resume-volume-work', id: this.detail.id } })
    },
    onPrint() {
      const url = `${process.env.VUE_APP_PRINT_URL}/WorkProgress?CcId=${this.detail.id}`
      window.open(url)
    },
    async updateStatus(comment) {
      try {
        this.isLoading = true
        const checkStatus = this.action === 'approve'
          ? await api.summaryResumeVolumeWork.approve(this.detail.id)
          : await api.summaryResumeVolumeWork.revise(this.detail.id, comment)
        if (checkStatus.data.error) {
          this.isLoading = false
          this.text = ''
          this.$nextTick(() => {
            this.$bvToast.toast(`${checkStatus.data.error.message}`, {
              headerClass: 'd-none',
              solid: true,
              variant: 'danger'
            })
          })
        } else {
          this.text = this.action === 'approve' ? 'Approve this document' : 'Reject this document'
          this.$bvModal.show('modal-successful')
          setTimeout(() => {
            this.$router.push('/summary-resume-volume-work')
          }, 1500)
        }
      } catch ({ response }) {
        this.isLoading = false
        this.text = ''
        this.$nextTick(() => {
          this.$bvToast.toast(`${response.status} ${response.data.error.message}`, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
    },
    itemRowBackground(status) {
      if (status.includes('Draft')) {
        return 'draft'
      } else if (status.includes('Approved')) {
        return 'approved'
      } else if (status.includes('Revise')) {
        return 'revised'
      } else if (status.includes('Waiting Approval')) {
        return 'waiting-approval'
      } else {
        return 'waiting-approval'
      }
    },
    fieldTable(index) {
      return [
        { key: 'type', label: 'Type', tdClass: 'text-center align-middle', thClass: 'border', thStyle: 'width: 100px' },
        { key: 'detail', label: this.detail.data[index].header, tdClass: 'text-center p-0', thClass: 'border', thStyle: 'width: 150px' },
        { key: 'volume', label: 'Jumlah', tdClass: 'text-center p-0', thClass: 'border', thStyle: 'width: 150px' },
        { key: 'unit', label: 'Unit', tdClass: 'text-center p-0', thClass: 'border', thStyle: 'width: 150px' },
        { key: 'destination', label: 'Tujuan', tdClass: 'text-center p-0', thClass: 'border', thStyle: 'width: fit-content' },
        { key: 'distance', label: 'Jarak (M)', tdClass: 'text-center p-0', thClass: 'border', thStyle: 'width: 150px' },
        { key: 'payment_status', label: 'Payment Status', tdClass: 'text-center p-0', thClass: 'border', thStyle: 'width: 150px' },
        { key: 'description', label: 'Keterangan', tdClass: 'text-center p-0', thClass: 'border', thStyle: 'width: 150px' }
      ]
    },
    getApprovalSign(roleName, pos) {
      let approveObj = {}
      if (roleName === 'Mine Plan Head') {
        approveObj = this.detail.approval_sign.find(obj => obj.department_name === 'MINE PLANNING')
      } else {
        approveObj = this.detail.approval_sign.find(obj => obj.name === roleName && obj.department_name !== 'MINE PLANNING')
      }
      if (pos === 'sign') {
        switch (roleName) {
          case 'Survey Owner': return approveObj?.fullname ? 'Created by' : ''
          case 'Manager Owner': return approveObj?.fullname ? 'Acknowledged' : ''
          default : return approveObj?.fullname ? 'Verified' : ''
        }
      } else {
        return approveObj?.fullname ?? '-'
      }
    }
  }
}
</script>

<style lang="scss">
.form-control {
  font-size: 12px;
}

.col-form-label, .col-form-label-sm {
  font-size: 12px !important;
}

.table-responsive {
  margin-bottom: 0;
}

.header-report {
  font-weight: bold;
  background-color: rgba(220, 239, 237, 0.48);
  font-size: 1.1vw;
  &.bottom {
    font-size: 0.9vw;
  }
}

.footer-report {
  font-size: 1vw;
  &.header {
    color: #fff;
    background-color: #00B4A5;
  }
  &.content {
    background-color: #DBF9F6;
    min-height: 70px;
  }
}
</style>
